.ar{padding:0.5rem;}